import { Flex, Select, Switch, TextInput } from "@mantine/core";
import Container from "../common/Container";
import styled from "styled-components";
import { useRef } from "react";
import { updateTerminalById } from "../../api/terminalApi";
import { useForm } from "@mantine/form";
import { updateNotification } from "../../utils/useNotification";
import { validateRequired } from "../../utils/validations";
import { useNavigate, useLocation } from "react-router";
import PageHeader from "../common/PageHeader";
import { useAuth } from "../../context/AuthContext";
import {
  CRL_AGE_DESCRIPTION,
  CRL_AGE_OPTIONS,
  DEFAULT_CRL_AGE_HOURS,
} from "../../utils/crlAge";


const TerminalUpdatePage = () => {
  const { company } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const tablet = location.state?.tablet;
  const formRef = useRef<HTMLFormElement>(null);

  const form = useForm({
    initialValues: {
      name: tablet?.name || "",
      location: tablet?.location || "",
      maxCrlAgeHours: String(tablet?.maxCrlAgeHours ?? DEFAULT_CRL_AGE_HOURS),
      // Kayıtta "1"/"0" string olarak duruyor; formda boolean tutulup gönderirken
      // geri çevriliyor (bkz. handleSubmit).
      autoControl: tablet?.autoControl === "1",
    },
    validate: {
      name: validateRequired,
      location: validateRequired,
    },
  });

  const handleSubmit = async (values: any) => {
    try {
      const { data }: any = await updateTerminalById({
        id: tablet?._id,
        updates: {
          name: values.name,
          location: values.location,
          // Backend şeması integer bekliyor (additionalProperties:false + type:integer),
          // Select ise string veriyor.
          maxCrlAgeHours: Number(values.maxCrlAgeHours),
          // ⚠ "1"/"0" STRING zorunlu (plan 2.56): backend şeması enum ["0","1"],
          // boolean 400 döner. Değer tabletin imzalı yayınının bir hanesi.
          autoControl: values.autoControl ? "1" : "0",
        },
      });
      updateNotification(data?.success);
      if (data?.success) {
        navigate("/tablets");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Container>
      <PageHeader
        pageTitle="Tablet Düzenle"
        subText="Aşağıdaki alanları güncelledikten sonra 'Güncelle' butonuna basınız."
        isButtoned
        buttonText="Güncelle"
        buttonOnClick={() => formRef.current?.requestSubmit()}
      />
      
      <Flex direction={"column"} gap={40} w={"min-content"}>
        <StyledForm ref={formRef} onSubmit={form.onSubmit(handleSubmit)}>
          
          <TextInput
            label="Şirket Kodu"
            value={company?.code}
            radius={10}
            size="md"
            readOnly
            variant="default" 
            style={{ pointerEvents: "none", opacity: 0.7 }} 
            tabIndex={-1} 
          />

          <TextInput
            label="Tablet İsmi"
            placeholder="İsim"
            radius={10}
            size="md"
            {...form.getInputProps("name")}
          />

          <TextInput
            label="Terminal Kodu"
            value={tablet?.terminalCode || tablet?.code || ""}
            radius={10}
            size="md"
            readOnly
            style={{ pointerEvents: "none", opacity: 0.7 }}
            tabIndex={-1}
          />

          <TextInput
            label="Tablet Konumu"
            placeholder="Konum"
            radius={10}
            size="md"
            {...form.getInputProps("location")}
          />

          <Switch
            label="Otomatik açılsın mı?"
            description="Kapalıysa mobil uygulamada giriş/çıkış manuel onayı gerektirir. Değişiklik terminale bir sonraki bağlantısında uygulanır."
            size="md"
            radius={10}
            {...form.getInputProps("autoControl", { type: "checkbox" })}
          />

          <Select
            label="Çevrimdışı erişim süresi"
            description="Terminal internetsizken, iptal listesi bu süreden eskiyse çevrimdışı kapı açma reddedilir. Değişiklik terminale bir sonraki bağlantısında uygulanır."
            data={CRL_AGE_OPTIONS}
            radius={10}
            size="md"
            allowDeselect={false}
            {...form.getInputProps("maxCrlAgeHours")}
          />

        </StyledForm>
      </Flex>
    </Container>
  );
};

export default TerminalUpdatePage;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 468px;
  
  
  .mantine-TextInput-input[readonly] {
    background-color: #f1f3f5; 
    border-color: #e9ecef;
    cursor: default;
  }
`;